import { useState, useEffect, useRef } from "react";

export function useParallax(speed: number = 0.5) {
  const [offset, setOffset] = useState(0);
  const rafId = useRef(0);

  useEffect(() => {
    // Disable on mobile/tablet to avoid scroll jank
    if (window.innerWidth < 1200) return;

    const handleScroll = () => {
      if (rafId.current) return;
      rafId.current = requestAnimationFrame(() => {
        setOffset(window.scrollY * speed);
        rafId.current = 0;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, [speed]);

  return offset;
}
